import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsConfig from './aws-exports';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { installGlobalErrorReporting } from './lib/reportClientError';

// Before anything else, so a failure in Amplify.configure or in App's own
// module-level code is still captured rather than vanishing into a blank page.
installGlobalErrorReporting();

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // ErrorBoundary sits outside StrictMode: it has to survive anything thrown
  // inside, including during the double-invoked renders StrictMode performs.
  <ErrorBoundary>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ErrorBoundary>
);
